import { createRouter, createWebHistory } from "vue-router";
import Home from "@/views/HomeView.vue";
import AudiPaymentView from "@/views/partner/AudiPaymentView.vue";
import AudiInstallStatusView from "@/views/partner/AudiInstallStatusView.vue";
import ReissueInvoiceView from "@/views/ReissueInvoiceView.vue";
import InstallationServiceSatisfactionSurvey from "@/views/InstallationServiceSatisfactionSurvey.vue";

import store from '@/store';

const routes = [
  {
    path: "/installation_service/:orderId/survey",
    name: "installation_service_survey",
    component: InstallationServiceSatisfactionSurvey,
    meta: { layout: 'default', title: '安心裝服務滿意度問卷　|　EVOASIS' }
  },
  {
    path: "/reissue_invoice/:token",
    name: "reissue_invoice",
    component: ReissueInvoiceView,
    meta: { layout: 'default', title: '發票服務　|　EVOASIS' }
  },
  {
    path: "/partner/audi/:orderId/payment",
    name: "AudiPayment",
    component: AudiPaymentView,
    meta: { layout: 'default', title: '結帳　|　EVOASIS x Audi車主充電樁安裝' }
  },
  {
    path: "/partner/audi/:orderId/status",
    name: "AudiInstallStatus",
    component: AudiInstallStatusView,
    meta: { layout: 'default', title: '安裝作業進度查詢　|　EVOASIS x Audi車主充電樁安裝' }
  },
  {
    path: "/session-start/:chargePoint?",
    name: "Home",
    component: Home,
  },
  {
    path: "/pay",
    name: "Pay",
    component: () => import("../views/PayView.vue"),
    meta: { requiresChargingPointId: true },
  },
  {
    path: "/pay_failure",
    name: "PayFailure",
    component: () => import("../views/PayFailureView.vue"),
  },
  {
    path: "/battery_progress/:sessionId?",
    name: "BatteryProgress",
    component: () => import("../views/BatteryProgressView.vue"),
  },
  {
    path: "/battery_confirm",
    name: "BatteryConfirm",
    component: () => import("../views/BatteryConfirmView.vue"),
    meta: { requiresChargingPointId: true },
  },
  {
    path: "/battery_access/:sessionId?",
    name: "BatteryAccess",
    component: () => import("../views/BatteryAccessViews.vue"),
  },
  {
    path: "/charging_connecting",
    name: "ChargingConnecting",
    component: () => import("../views/ChargingConnectingViews.vue"),
  },
  {
    path: "/charging_progress/:sessionId?",
    name: "ChargingProgress",
    component: () => import("../views/ChargingProgressViews.vue"),
  },
  {
    path: "/charging_ending",
    name: "ChargingEnding",
    component: () => import("../views/ChargingEndingViews.vue"),
  },
  {
    path: "/charging_fail",
    name: "ChargingFail",
    component: () => import("../views/ChargingFailViews.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  console.log(to)
  console.log(from)
  console.log(store.state.chargingPointId)
  if (to.meta.requiresChargingPointId && !store.state.chargingPointId) {
    next({ name: "Home" });
  } else {
    next();
  }
})
export default router;
